export const ComponentNames = {
  monitoringDashboard: 'monitoring-dashboard',
  deviceDetail: 'device-detail',
  nodeList: 'node-list',
  endPoints: 'endpoints',
  sampleDetails: 'sampleDetails'
};
